// extracted by mini-css-extract-plugin
module.exports = {"img":"index-module_img_u9cKQ"};